import React from "react";
import { Link } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import MobileMenus from "./MobileMenus";

const OffCanvas = ({ setOffCanvas, isOffCanvas }) => {
  return (
    <>
      <div
        className={`offcanvas__area off-canvas-bg ${isOffCanvas ? "opened" : ""
          }`}
        style={{ backgroundImage: `url("assets/img//bg/Sidearea-bg-img.png")` }}
      >
        <div className="offcanvas_area-logo">
          <span className="offcanvas__close-btn">
            <button onClick={() => setOffCanvas(false)}>
              <i className="fal fa-times" />
            </button>
          </span>
        </div>
        <div className="offcanvas-content">
          <div className="offcanvas-subtitle">
            <span>ELEVATE YOUR BUSINESS WITH</span>
          </div>
          <div className="offcanvas-logo pb-30 pt-30 p-5 ms-5  rounded">
            <img src="assets/img/logo/clubnet_logo .png" className="w-75 " style={{ border: '8px solid #fff', borderRadius: '4px' }} alt="" />
          </div>
          <div className="offcanva-details ">
            <p>
              ClubNet offers consulting services to help businesses identify their IT needs and develop strategies for implementing technology solutions that align with their goals and budget.


            </p>
          </div>
          <div className="offcanva-btn">
            <Link
              to="/Contact_Us"
              className="tp-slider-btn mt-40 d-inline-block"
              tabIndex="-1"
            >
              <span>
                <svg
                  width="53"
                  height="8"
                  viewBox="0 0 53 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M52.3536 4.35356C52.5488 4.15829 52.5488 3.84171 52.3536 3.64645L49.1716 0.464469C48.9763 0.269207 48.6597 0.269207 48.4645 0.464469C48.2692 0.659731 48.2692 0.976314 48.4645 1.17158L51.2929 4L48.4645 6.82843C48.2692 7.02369 48.2692 7.34027 48.4645 7.53554C48.6597 7.7308 48.9763 7.7308 49.1716 7.53554L52.3536 4.35356ZM-3.11023e-08 4.5L52 4.5L52 3.5L3.11023e-08 3.5L-3.11023e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <svg
                  width="53"
                  height="8"
                  viewBox="0 0 53 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M52.3536 4.35356C52.5488 4.15829 52.5488 3.84171 52.3536 3.64645L49.1716 0.464469C48.9763 0.269207 48.6597 0.269207 48.4645 0.464469C48.2692 0.659731 48.2692 0.976314 48.4645 1.17158L51.2929 4L48.4645 6.82843C48.2692 7.02369 48.2692 7.34027 48.4645 7.53554C48.6597 7.7308 48.9763 7.7308 49.1716 7.53554L52.3536 4.35356ZM-3.11023e-08 4.5L52 4.5L52 3.5L3.11023e-08 3.5L-3.11023e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              Get in touch
            </Link>
          </div>
        </div>

        <div className="tp-mobile-menu mean-container d-block d-xl-none">
          <div className="mean-bar">
            <MobileMenus />
          </div>
        </div>




        <div className="tp-footer__widget pb-30 offcanvas-ct-info">
          <h3 className="tp-footer__widget-title">Quick Links</h3>
          <ul>
            <li>
              <Link to="#"> Palasia office, 405, The Mark, 20-A, Anand Bazaar Square, Old Palasia, Indore, Madhya Pradesh 452001</Link>
            </li>
            <li>
              <Link to="tel:+88015569569365">(+91) 99930 53695</Link>
            </li>
            <li>
              <Link to="mailto:support@example.com">info@clubnet.in</Link>
            </li>
            <li>
              <span> Office Hours: 10AM - 7PM</span>
            </li>
            
            <li className="d-flex  align-items-center">
            
             <a href="https://www.facebook.com/people/Club-Net/pfbid02BJ3wuFgWnUSP1YPUd7Srhi3rTcyb3fLYeC4infuhHrSiNUkvvzoWdTWgKaXVVtc2l/" target="_blank" rel="noopener noreferrer" className="me-2 ms-3 fs-5">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.linkedin.com/in/clubnet-b8b647318/" target="_blank" rel="noopener noreferrer" className="me-2 ms-3 fs-5">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.instagram.com/clubn_et/" target="_blank" rel="noopener noreferrer" className="ms-3 fs-5">
                <i className="fab fa-instagram"></i>
              </a>
            </li>

          </ul>
        </div>
      </div>
      <div
        onClick={() => setOffCanvas(false)}
        className={`body-overlay ${isOffCanvas ? "opened" : ""}`}
      ></div>
    </>
  );
};

export default OffCanvas;
